<template>
    <div>

        <!-- Dialog: Delete Confirmation -->
        <v-dialog v-model="dialog_delete" persistent max-width="400">           
            <v-card>
                <v-card-title class="headline">Liste  {{edit_item.name}} löschen  ?</v-card-title>
                <v-card-text>
                    Vorsicht, die Daten werden endgültig gelöscht.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat @click="ui_event_delete_item()">Delete</v-btn>
                    <v-btn color="green darken-1" flat @click="dialog_delete = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog: Valid From Picker -->
        <v-dialog ref="ref_dialog_valid_from"
                  v-model="dialog_valid_from"
                  :return-value.sync="edit_item_helper_valid_from"
                  width="290px">

            <v-date-picker v-model="edit_item_helper_valid_from"
                           scrollable>
                <v-spacer></v-spacer>
                <v-btn text
                       color="primary"
                       @click="dialog_valid_from = false">
                    Cancel
                </v-btn>

                <v-btn text
                       color="primary"
                       @click="$refs.ref_dialog_valid_from.save(edit_item_helper_valid_from)">
                    OK
                </v-btn>
            </v-date-picker>

        </v-dialog>

        <!-- Dialog: Valid To Picker -->
        <v-dialog ref="ref_dialog_valid_to"
                  v-model="dialog_valid_to"
                  :return-value.sync="edit_item_helper_valid_to"
                  width="290px">

            <v-date-picker v-model="edit_item_helper_valid_to"
                           scrollable>
                <v-spacer></v-spacer>
                <v-btn text
                       color="primary"
                       @click="dialog_valid_to = false">
                    Cancel
                </v-btn>

                <v-btn text
                       color="primary"
                       @click="$refs.ref_dialog_valid_to.save(edit_item_helper_valid_to)">
                    OK
                </v-btn>
            </v-date-picker>

        </v-dialog>

        <h2 v-if="ACTION=='NEW'">Neuer Eintrag</h2>
        <h2 v-if="ACTION=='UPDATE'">Eintrag ändern: {{edit_item.name}}</h2>
        <h2 v-if="ACTION=='NONE'">Übersicht - CoList</h2>


        <div style="display:flex; justify-content:space-between">
            <div style="flex-grow:1"></div>
            <div style="flex-grow:0">
                <v-btn v-if=!ui_show_form small flat color="blue" v-on:click="ui_event_button_new_entry()">
                    New Entry
                </v-btn>
                <v-btn v-if=!ui_show_form small flat color="blue" v-on:click="ui_event_button_count()">
                    Count
                </v-btn>
            </div>
        </div>

        <v-btn v-if=ui_show_form :disabled="!form_input_valid" small flat color="blue" v-on:click="ui_event_button_save()">
            Save
        </v-btn>

        <v-btn v-if=ui_show_form small flat color="blue" v-on:click="ui_event_button_cancel()">
            Cancel
        </v-btn>

    <!-- Data Entry Form -->
        <div v-if="ui_show_form">
            <v-form v-model="form_input_valid">


                <v-text-field v-model="edit_item.id"
                              v-if="ACTION=='NEW'"
                              label="Name"
                              :rules="[]">
                </v-text-field>



                <v-text-field v-model="edit_item.meta.first_id"
                              label="First Id"
                              :rules="[rules.isnum]"></v-text-field>

                <v-text-field v-model="edit_item.meta.next_id"
                              label="Next Id"
                              :rules="[rules.isnum]"></v-text-field>

                <v-text-field v-model="edit_item.meta.note"
                              label="Note"
                              :rules="[]"></v-text-field>


                <v-text-field v-model="edit_item.meta.code"
                              label="Code (vierstellige Zahl)"
                              :rules="[rules.isnum]"></v-text-field>

                <v-text-field v-model="edit_item_helper_valid_from"
                              label="Valid from (incl.)"
                              read_only
                              @click="dialog_valid_from=true"></v-text-field>

                <v-text-field v-model="edit_item_helper_valid_to"
                              label="Valid to (incl.)"
                              read_only
                              @click="dialog_valid_to=true"></v-text-field>

            </v-form>





        </div>

        <div v-if="!ui_show_form">
            <v-data-table :headers="listHeaders"
                          :items="listData"
                          :pagination.sync="pagination"
                          class="elevation-1">


                <template slot="items" slot-scope="props">


                    <td class="text-xs-left">{{ props.item.id}}</td>
                    <td class="text-xs-left">{{ props.item.meta.note }}</td>
                    <td class="text-xs-left">{{ props.item.meta.doc_count }}</td>
                    <td class="text-xs-left">{{ props.item.meta.first_id + " / "+ props.item.meta.next_id}}</td>
                    <td class="text-xs-left">{{ props.item.meta.code }}</td>
                    <td class="text-xs-left">{{ ui_helper_date(props.item.meta.valid_from) }}</td>
                    <td class="text-xs-left">{{ ui_helper_date(props.item.meta.valid_to) }}</td>
                    <td class="justify-center layout px-0">
                        <v-icon small
                                class="mr-2"
                                @click="ui_event_edit_item(props.item)">
                            edit
                        </v-icon>
                        <v-icon small
                                @click="ui_event_delete_dialog(props.item)">
                            delete
                        </v-icon>
                        <v-icon small
                                @click="ui_event_show_list(props.item)">
                            subject
                        </v-icon>
                    </td>
                </template>
            </v-data-table>
        </div>
        <div class="caption">
            Current UTC: {{ ui_helper_date(new Date()) }}
        </div>
        <!-- Detailed List -->
        <div v-for="line in listDetails" :key="line">
            <div>{{line}}</div>
        </div>
    </div>
</template>

<script>
const k = 1;

import firebase from "firebase/app";
import "firebase/firestore";
import { Utils } from "./../../classes/Utils.js";
import { FirebaseTable } from "./../table/FirebaseTable.js";

export default {
  data() {
    return {
      fbTables: {},

      ui_title: "Access Lists",
      ui_show_form: false,

      modal: false,

      ACTION: "NONE", // NEW, UPDATE

      // Mirror-Variables for form
      edit_item: {},
      edit_item_helper_valid_from: new Date().toISOString().substr(0, 10),
      edit_item_helper_valid_to: new Date().toISOString().substr(0, 10),
      form_input_valid: true,

      ui_show_menu: true,

      // Dialogs used
      dialog_delete: false,
      dialog_valid_from: false,
      dialog_valid_to: false,

      // Tabelle mit den Daten
      listData: [],

      // Tabele mit den Details dr gewählten Liste
      listDetails: [],

      pagination: {
        sortBy: "counter",
        descending: true,
        rowsPerPage: -1,
      },

      listHeaders: {},

      rules: {
        required: (value) => !!value || "Required",

        min: (value) => value.length >= 6 || this.$t("signUp.passwordMessage"),

        isnum: (value) => /^\d+$/.test(value) || "Bitte Zahl eingeben.",

        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("global.invalidEmail");
        },
      },
    };
  },

  computed: {},

  methods: {
    // Tempor�r, um die Accountinfo an den Us

    ui_event_edit_item(item) {
      this.ACTION = "UPDATE";
      this.edit_item = Object.assign({}, item);
      this.edit_item_helper_valid_from = this.edit_item.meta.valid_from
        .toISOString()
        .substr(0, 10);
      this.edit_item_helper_valid_to = this.edit_item.meta.valid_to
        .toISOString()
        .substr(0, 10);
      this.ui_show_form = true;
    },

    ui_event_delete_dialog(item) {
      if (item.meta.next_id > item.meta.first_id) {
        this.$store.commit(
          "setSnackbarText",
          "Diese Liste hat anscheinend Daten. Direkt in DB machen!"
        );
        return;
      }
    },

    ui_event_delete_item() {
      this.fbTables = new FirebaseTable(this.edit_item.id);
      this.fbTables.delete_table(this.edit_item.id);
    },

    ui_event_button_new_entry() {
      this.ACTION = "NEW";

      this.edit_item = {};

      // Init the new item
      this.edit_item.id = "XY";
      this.edit_item.meta = this.fbTables.get_default_meta_object();

      this.edit_item.meta.valid_to = new Date();
      this.edit_item.meta.valid_to.setUTCDate(
        this.edit_item.meta.valid_to.getUTCDate() + 7
      );
      this.edit_item.meta.valid_to.setUTCHours(0);
      this.edit_item.meta.valid_to.setUTCMinutes(0);
      this.edit_item.meta.valid_to.setUTCSeconds(0);

      this.edit_item.meta.version = "1";

      //... an define helpers as needed...
      this.edit_item_helper_valid_from = this.edit_item.meta.valid_from
        .toISOString()
        .substring(0, 10);
      this.edit_item_helper_valid_to = this.edit_item.meta.valid_to
        .toISOString()
        .substring(0, 10);

      // Manage the UI
      this.ui_show_form = true;
    },

    ui_event_button_cancel() {
      this.ui_show_form = false;
      this.ACTION = "NONE";
    },

    ui_event_button_save() {
      this.edit_item.meta.valid_from = new Date(
        this.edit_item_helper_valid_from
      );
      this.edit_item.meta.valid_to = new Date(this.edit_item_helper_valid_to);
      this.edit_item.meta.first_id = parseInt(this.edit_item.meta.first_id);
      this.edit_item.meta.next_id = parseInt(this.edit_item.meta.next_id);

      this.fbTables.create_table(this.edit_item.id, this.edit_item.meta);
      this.ui_show_form = false;
    },

    async ui_event_button_count() {
      var n = 0;
      this.listData.forEach((table) => {
        n = this.fbTables.set_count(table.id);
        n.then((i) => {
          table.meta.doc_count = i;
        });
        console.log("Count ", table.id, " : ", n);
      });
    },

    ui_helper_date(date) {
      return Utils.getGermanDate(date);
    },

    async ui_event_show_list(item) {
      this.listDetails= [];
      var entries  = await this.fbTables.get_lines_with_key( item.id);
      console.log( "Finished" )
      let c = 0;

      var sap_list = []

      entries.forEach((entry) => {
          
          c = c + 1;
          // Decide on the type of the entry
          let selected;
            console.log( entry.data )
          // ----------------- Klausureinsicht
          if (entry.data.selection) {
            for (selected of entry.data.selection) {
              console.log( entry.key, "-", selected )
              this.listDetails.push(c + "; " + entry.key + "; " + selected);
            }
          }

          // A sap access list entry list
          if (entry.data.account) {
          sap_list.push({
            email: entry.data.email,
            timestamp: entry.data.timestamp,
            account: entry.data.account            
           })
          }       
      });

      // Postprocessing if SAP-List
      if (sap_list.length > 0){
         console.log( "Prcocessing SAP List")
         // Sort the list
         sap_list.sort( function(a,b){
          if (a.account < b.account) return +1
          if (a.account > b.account) return -1
          return 0          
         }) 

         // Create list for UI
         c = 1
         sap_list.forEach((entry) => {
            this.listDetails.push(c + "; " + entry.account + "; " + entry.email + ";" + entry.timestamp.toDate());
            c = c +1 
         })         
      }
    },

    get_list_header() {
      return [
        {
          text: "Name (Id)",
          align: "left",
          sortable: true,
          value: "name",
        },

        {
          text: "Note",
          align: "left",
          sortable: false,
          value: "note",
        },

        {
          text: "Count",
          align: "left",
          sortable: false,
          value: "doc_count",
        },

        {
          text: "First/Next Id",
          align: "left",
          sortable: false,
          value: "first_id",
        },

        {
          text: "Code",
          align: "left",
          sortable: false,
          value: "access_code",
        },

        {
          text: "From (UTC)",
          align: "center",
          sortable: false,
          value: "action",
        },

        {
          text: "To (UTC)",
          align: "center",
          sortable: false,
          value: "action",
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
          value: "action",
        },
      ];
    },

    transfer_date(fbDate) {
      if (!fbDate) return new Date("1970-01-01");
      else return fbDate.toDate();
    },
  },

mounted() {
    console.log("Mounted Component : CoList.vue");
  },

  async created() {
    console.log("AccessList created...");

    this.fbTables = new FirebaseTable();
    this.listHeaders = this.get_list_header();

    console.log("Start wait ...");
    this.listData = await this.fbTables.get_tables();
    console.log("Resolved ...");
    // Convert database data into data, that can be processed...
    this.listData.forEach((table) => {
      table.meta.valid_from = this.transfer_date(table.meta.valid_from);
      table.meta.valid_to = this.transfer_date(table.meta.valid_to);
      console.log("vvvv ", table.meta.valid_to);
    });

    console.log("List data : ", this.listData);
  },
};
</script>
